import { baseApi } from 'api/api-base';
import { Auth, Logout } from 'types/api/auth.types';
import { API_ROUTES } from 'constants/api-routes';

export const authApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    authenticate: builder.query<Auth.ResponseType, Auth.RequestType>({
      query: ({ tenant, redirect_url = window.location.origin }) => ({
        url: API_ROUTES.AUTHENTICATE,
        params: { tenant, redirect_url },
      }),
      extraOptions: {},
    }),
    logOut: builder.query<Logout.ResponseType, Logout.RequestType>({
      query: () => ({
        method: 'POST',
        url: API_ROUTES.LOGOUT,
      }),
      extraOptions: {},
    }),
  }),
});

export const { useLazyAuthenticateQuery, useLazyLogOutQuery } = authApi;
